/**
 * Entries in `assigned_learner_maps` that are not presented as learner maps in
 * their own right — they are reached from elsewhere in the app, so listing them
 * would duplicate navigation. Shared by the side nav and the dashboard's
 * "Current Learner Map" card so the two can't drift apart.
 */
export const EXCLUDED_LEARNER_MAP_TITLES = [
  'My Profile',
  'Presenting',
  'Presenting Mindset',
  'Promoting',
];
